"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERMISSION_LEVELS = exports.PERMISSION_OBJECT_TYPES = void 0;
exports.PERMISSION_OBJECT_TYPES = [
    'courseGroups',
    'manageSections',
    'guides',
    'wikis',
    'workspaces',
];
exports.PERMISSION_LEVELS = ['none', 'view', 'edit', 'assign', 'comment', 'manage'];
